import { render, staticRenderFns } from "./ChooseTicketGood.vue?vue&type=template&id=a93e3820&scoped=true"
import script from "./ChooseTicketGood.vue?vue&type=script&lang=js"
export * from "./ChooseTicketGood.vue?vue&type=script&lang=js"
import style0 from "./ChooseTicketGood.vue?vue&type=style&index=0&id=a93e3820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93e3820",
  null
  
)

export default component.exports